// services/storeService.js
import api from './api';

/**
 * Получение списка всех магазинов с параметрами фильтрации
 * @param {Object} params - Параметры запроса
 * @param {boolean} includeInactive - Включать ли неактивные записи
 * @returns {Promise<Array>} Массив магазинов
 */
export const getStores = async (params = {}, includeInactive = true) => {
  // Добавляем параметр для включения неактивных записей
  const queryParams = { 
    ...params,
    includeInactive: includeInactive 
  };
  
  const response = await api.get('/stores', { params: queryParams });
  return response.data;
};

/**
 * Получение магазина по ID
 * @param {number} id - ID магазина
 * @returns {Promise<Object>} Данные магазина
 */
export const getStoreById = async (id) => {
  const response = await api.get(`/stores/${id}`);
  return response.data;
};

/**
 * Создание нового магазина
 * @param {Object} storeData - Данные для создания магазина
 * @returns {Promise<Object>} Созданный магазин
 */
export const createStore = async (storeData) => {
  const response = await api.post('/stores', storeData);
  return response.data;
};

/**
 * Обновление существующего магазина
 * @param {number} id - ID магазина
 * @param {Object} storeData - Данные для обновления
 * @returns {Promise<Object>} Обновленный магазин
 */
export const updateStore = async (id, storeData) => {
  const response = await api.put(`/stores/${id}`, storeData);
  return response.data;
};

/**
 * Деактивация магазина (мягкое удаление через DELETE запрос)
 * @param {number} id - ID магазина
 * @returns {Promise<Object>} Результат операции
 */
export const deactivateStore = async (id) => {
  const response = await api.delete(`/stores/${id}`);
  return response.data;
};

/**
 * Активация магазина (через обновление)
 * @param {number} id - ID магазина
 * @param {Object} storeData - Полные данные магазина
 * @returns {Promise<Object>} Обновленный магазин
 */
export const activateStore = async (id, storeData) => {
  // Добавляем поле isActive в true
  const dataWithActive = {
    ...storeData,
    isActive: true
  };
  const response = await api.put(`/stores/${id}`, dataWithActive);
  return response.data;
};

export default {
  getStores,
  getStoreById,
  createStore,
  updateStore,
  deactivateStore,
  activateStore
};